/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Caption_Track_HelpInputs */



/**
* | output |
* | --- |
* | "Select the caption track to embed" |
*
* @param {Embed_Captions_Caption_Track_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_caption_track_help = /** @type {((inputs?: Embed_Captions_Caption_Track_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Caption_Track_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionnez la piste de sous-titres a incruster")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie die einzubettende Untertitelspur aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona la traccia dei sottotitoli da incorporare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите дорожку субтитров для встраивания.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione la pista de subtítulos que desea incrustar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择要嵌入的字幕轨道。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("埋め込むキャプショントラックを選択してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कैप्शन ट्रैक का चयन करें जिसे आप एम्बेड करना चाहते हैं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione a faixa de legenda que deseja incorporar.")
	return /** @type {LocalizedString} */ ("Select the caption track to embed")
});